var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.75022L13.1875 9.68772C13.3273 9.82708 13.4383 9.99267 13.514 10.175C13.5897 10.3573 13.6287 10.5528 13.6287 10.7502C13.6287 10.9476 13.5897 11.1431 13.514 11.3255C13.4383 11.5078 13.3273 11.6734 13.1875 11.8127L11.8125 13.1877C11.6731 13.3276 11.5076 13.4385 11.3252 13.5142C11.1429 13.5899 10.9474 13.6289 10.75 13.6289C10.5526 13.6289 10.3571 13.5899 10.1748 13.5142C9.99244 13.4385 9.82686 13.3276 9.6875 13.1877L7.75 11.2502",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5L14.5 14.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5L3.5 3.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.25L10.5 8.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9.25L8.5 10.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25075 4.75L6.31325 2.8125C6.1739 2.67266 6.00831 2.5617 5.82598 2.486C5.64365 2.41029 5.44817 2.37132 5.25075 2.37132C5.05333 2.37132 4.85785 2.41029 4.67553 2.486C4.4932 2.5617 4.32761 2.67266 4.18825 2.8125L2.81325 4.1875C2.67341 4.32686 2.56246 4.49244 2.48675 4.67477C2.41104 4.8571 2.37207 5.05258 2.37207 5.25C2.37207 5.44742 2.41104 5.6429 2.48675 5.82523C2.56246 6.00756 2.67341 6.17314 2.81325 6.3125L4.75075 8.25",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 8.75L8.75 4.25",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11.75L11.75 7.25",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderInactive);
export default __webpack_public_path__ + "static/media/calender_inactive.c928b0b06d4939617d2f1fc9a92f682d.svg";
export { ForwardRef as ReactComponent };